import React from "react";

import {
    Form, Input,
} from 'antd';
// import { AntInputField } from "dform-core";

import { RegistComponent, FieldBase } from "easyui-core";
import { WfComponentProps } from "../../WfComponent/WfComponentProps";

export class AntInput extends React.Component<WfComponentProps> {
    field: FieldBase<any>
    constructor(props) {
        super(props)
        this.field = this.props.field
    }
    handleValueChange = (value) => {
        debugger
    }
    render() {
        const { formLayout } = this.props;
        const { getFieldDecorator } = this.props.form;
        const formItemLayout = formLayout === 'horizontal' ? {
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
        } : null;
        // const formItemLayout = null

        return (
            <Form.Item {...formItemLayout} label={this.props.field.label}>
                {getFieldDecorator(this.field.key, {
                    rules: [{
                        validator: this.field.validator
                        // type: this.field.validator, message: 'The input is not valid E-mail!',
                    }, {
                        required: this.field.required, message: '必填项!',
                    }],
                })(
                    <Input disabled={this.field.disabled} onChange={this.handleValueChange} />
                )}
            </Form.Item>
        )
    }
}
RegistComponent({
    selector: "ef-ant-input",
    component: AntInput,
    name: "Ant输入框"
})
// export default AntInput